export const DAY_FORMAT = "MMM D, YYYY";
export const TIME_FORMAT = "h:mm A";
//# sourceMappingURL=constants.js.map